import { Map, Record } from 'immutable';

export interface SectionState extends Map<string, any> {
    sectionList: any;
    sectionListCount: any;
    deleteSection: any;
    addSection: any;
    newSection:any;
    updateSection:any

    sectionListLoaded: boolean;
    sectionListFailed: boolean;
    sectionListLoading: boolean;

    sectionListCountLoaded: boolean;
    sectionListCountFailed: boolean;
    sectionListCountLoading: boolean;

    sectionDeleteLoading: boolean;
    sectionDeleteLoaded: boolean;
    sectionDeleteFailed: boolean;

    sectionAddLoaded: boolean;
    sectionAddFailed: boolean;
    sectionAddLoading: boolean;

    sectionUpdateLoading: boolean;
    sectionUpdateLoaded: boolean;
    sectionUpdateFailed: boolean;

    getSectionDetails: any;
  getSectionDetailsLoaded: boolean;
  getSectionDetailsFailed: boolean;
  getSectionDetailsLoading: boolean;


}

export const SectionRecordState = Record({

    sectionList: [],
    sectionListCount: {},
    addSection: {},
    newSection:{},
    updateSection:{},
    getSectionDetails:{},


    sectionListLoaded: false,
    sectionListFailed: false,
    sectionListLoading: false,

    sectionListCountLoaded: false,
    sectionListCountFailed: false,
    sectionListCountLoading: false,

    sectionDeleteLoading: false,
    sectionDeleteLoaded: false,
    sectionDeleteFailed: false,

    sectionAddLoaded: false,
    sectionAddFailed: false,
    sectionAddLoading: false,

    sectionUpdateLoading: false,
    sectionUpdateLoaded: false,
    sectionUpdateFailed: false,

    getSectionDetailsLoaded: false,
    getSectionDetailsFailed: false,
    getSectionDetailsLoading: false
});